import { render, staticRenderFns } from "./DriveColumnMapper.vue?vue&type=template&id=2fdfa854&scoped=true"
import script from "./DriveColumnMapper.vue?vue&type=script&lang=js"
export * from "./DriveColumnMapper.vue?vue&type=script&lang=js"
import style0 from "./DriveColumnMapper.vue?vue&type=style&index=0&id=2fdfa854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdfa854",
  null
  
)

export default component.exports